import * as yup from 'yup';
import {
  hasPhotovoltaik,
  isPhotovoltaikMitversichert,
} from '@/features/Sparten/woh/formConfigs/sharedRenderConditions';
import { isDateAfterBaujahr } from '@/features/Sparten/woh/schema/helper';

export const photovoltaikSchema = yup.object({
  feuerwehrschalter: yup
    .boolean()
    .default(false)
    .when({
      is: () => hasPhotovoltaik(),
      then: yup.boolean().required(),
    }),
  mitversicherung: yup
    .string()
    .default('')
    .when({
      is: () => hasPhotovoltaik(),
      then: yup.string().required(),
    }),
  montage: yup
    .string()
    .default('')
    .when({
      is: () => isPhotovoltaikMitversichert(),
      then: yup.string().required(),
    }),
  neuwert: yup
    .number()
    .default(0)
    .when({
      is: () => isPhotovoltaikMitversichert(),
      then: yup.number().required().min(500),
    }),
  baujahr: yup
    .number()
    .default(0)
    .when({
      is: () => isPhotovoltaikMitversichert(),
      then: yup.number().required().test(isDateAfterBaujahr).min(1950),
    }),
  leistung: yup
    .number()
    .default(0)
    .when({
      is: () => isPhotovoltaikMitversichert(),
      then: yup.number().required().min(1).max(100),
    }),
  flaeche: yup
    .number()
    .default(0)
    .when({
      is: () => isPhotovoltaikMitversichert(),
      then: yup.number().required().min(1).max(1000),
    }),
});
